export type { NumberCardProps } from './NumberCard.types'
export { default as NumberCard } from './NumberCard'